exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".selection-tip[data-v-1eb78d6c]{margin-bottom:10px;color:#606266;font-weight:600}.version-source[data-v-1eb78d6c]{margin-top:3px;color:#909399;font-size:12px;line-height:16px}", ""]);

// exports
